module.exports = __webpack_public_path__ + "static/media/single.f4018e0b.png";